module.exports = __webpack_public_path__ + "assets/Retina-ThinItalic.f991b000ee6f4c196bb2ff3aa11c7bf6.woff";